import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperationRoutingModule } from './operation-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NgbDropdownModule, NgbNavModule, NgbPaginationModule, NgbTypeaheadModule, NgbHighlight, NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
// import { DataTablesModule } from 'angular-datatables';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AgGridModule } from 'ag-grid-angular';

// pickup
import { ListPickupComponent } from 'src/app/components/operation/pickup/list/listpickup.component';
import { AddPickupComponent } from 'src/app/components/operation/pickup/add/addpickup.component';
import { EditPickupComponent } from 'src/app/components/operation/pickup/edit/editpickup.component';
// manifest
import { ListManifestComponent } from 'src/app/components/operation/manifest/list/listmanifest.component';
import { AddManifestComponent } from 'src/app/components/operation/manifest/add/addmanifest.component';
import { ManifestInboundComponent } from 'src/app/components/operation/manifest-inbound/manifestinbound.component';
import { AddressBookService } from 'src/app/services/general/addressbook.service';
import { PickupService } from 'src/app/services/operations/pickup.service';
import { ShipperService } from 'src/app/services/general/shipper.service';
import { AWBService } from 'src/app/services/operations/awb.service';
import { ManifestService } from 'src/app/services/operations/manifest.service';
import { VendorServiceMapping } from 'src/app/services/vendor-service.service';
//drsScan
import { DRSComponent } from 'src/app/components/operation/drs-scan/add/drs.component';
import { ListDRSComponent } from 'src/app/components/operation/drs-scan/list/list.component';
import { DRSService } from 'src/app/services/operations/drs.service';
import { RateUploadComponent } from 'src/app/components/operation/rate-management/upload/rateupload.component';
import { VendorService } from 'src/app/services/vendor.service';
import { RateUploadService } from 'src/app/services/operations/rateupload.service';
import { RateDetailsComponent } from 'src/app/components/operation/rate-management/upload/details/ratedetails.component';
import { RateBandsService } from 'src/app/services/ratebands.service';
import { RatePeriodComponent } from 'src/app/components/operation/rate-management/upload/periods/rateperiod.component';
import { RateCompareComponent } from 'src/app/components/operation/rate-management/compare/ratecompare.component';
import { CustomerService } from 'src/app/services/customer.service';
import { ProductService } from 'src/app/services/products.service';
import { NetworkService } from 'src/app/services/network.service';
import { ExcelService } from 'src/app/services/excel.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { AwbEditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/awb-editdelete.component';
import { TransferPickupsComponent } from 'src/app/components/operation/pickup/pickup-transfer/transfer.component';
import { BulkAssignPickupsComponent } from 'src/app/components/operation/pickup/pickup-bulk-assign/bulk-assign.component';
import { ZoneService } from 'src/app/services/zone.service';
import { MiscService } from 'src/app/services/misc/misc.service';
import { BaggingComponent } from 'src/app/components/operation/manifest/bagging/bagging.component';
import { CreditControlService } from 'src/app/services/system-config/credit-control/creditcontrol';
import { CompanyService } from 'src/app/services/company.service';
import { UploadDRSCopyComponent } from 'src/app/components/operation/drs-scan/upload-copy/upload-copy.component';
import { UpdateStatusComponent } from 'src/app/components/operation/manifest/update-status/update-status.component';
import { ChargesService } from 'src/app/services/system-config/charges/charges.service';
// import { AngularDualListBoxModule } from 'angular-dual-listbox';

@NgModule({
  declarations: [
    ListPickupComponent,
    AddPickupComponent,
    EditPickupComponent,

    ListManifestComponent,
    AddManifestComponent,
    ManifestInboundComponent,

    ListDRSComponent,
    DRSComponent,
    UploadDRSCopyComponent,

    RateUploadComponent,
    RateDetailsComponent,
    RatePeriodComponent,
    RateCompareComponent,
    AwbEditDeleteActionsRenderer,
    TransferPickupsComponent,
    BulkAssignPickupsComponent,
    //InvoiceComponent,
    BaggingComponent,

    UpdateStatusComponent
  ],
  imports: [
    CommonModule,
    OperationRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbHighlight,
    NgbNavModule,
    NgbDropdownModule,
    NgbTypeaheadModule,
    NgbPaginationModule,
    NgSelectModule,
    // DataTablesModule,
    CKEditorModule,
    AgGridModule,
    NgbModule,
  ],
  exports: [
    ListPickupComponent,
    AddPickupComponent,
    EditPickupComponent,

    ListManifestComponent,
    AddManifestComponent,
    ManifestInboundComponent,
    ListDRSComponent,
    DRSComponent,
    UploadDRSCopyComponent,

    RateUploadComponent,
    RateDetailsComponent,
    RateCompareComponent,
    RatePeriodComponent,
    AwbEditDeleteActionsRenderer,
    TransferPickupsComponent,
    BulkAssignPickupsComponent,
    BaggingComponent,
    UpdateStatusComponent
  ],
  providers: [
    ShipperService,
    AddressBookService,
    PickupService,
    AWBService,
    ManifestService,
    // ServiceCenterService,
    NetworkService,
    DRSService,
    VendorService,
    RateUploadService,
    RateBandsService,
    CustomerService,
    ProductService,
    ExcelService,
    UserManagementService,
    NgbActiveModal,
    ZoneService,
    MiscService,
    CreditControlService,
    CompanyService,
    ChargesService
  ]
})
export class OperationModule { }